import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Search from '../SearchRM';

let timeout = 0;

const SearchAutocomplete = ({
  classes,
  search,
  suggestions,
  setSearch,
  onSearch,
  getSuggestions,
  isAutoCompleteEnabled,
  isTrackerSearch = false,
}) => {
  const [searchRef, setSearchRef] = React.useState(null);

  React.useEffect(() => {
    if (isAutoCompleteEnabled) getSuggestions(search);
  }, [search]);

  const onAutocompleteChange = (e, value) => {
    if (value) {
      setSearch(value);
      clearTimeout(timeout);
      onSearch(value);
    }
  };

  const onKeyDown = (e) => {
    if (e.key === 'Enter') {
      const { value } = e.target;
      timeout = setTimeout(() => onSearch(value));
      searchRef.current.blur();
    }
  };

  const placeholderText = isTrackerSearch ? 'Search trackers' : 'Search products';
  return (
    <Fragment>
      <Autocomplete
        classes={{
          popper: classes.container,
          option: classes.option,
          paper: classes.paper,
        }}
        id="search-autocomplete"
        options={suggestions}
        value={search}
        freeSolo
        selectOnFocus={false}
        onChange={isAutoCompleteEnabled ? onAutocompleteChange : () => null}
        renderInput={(params) => {
          setSearchRef(params.inputProps.ref);
          return (
            <Search
              placeholder={placeholderText}
              search={search}
              applySearch={setSearch}
              onClear={() => onSearch('', true)}
              withDebounce
              isHeaderWithin
              hasClear
              autoFocus={!search}
              onKeyDown={onKeyDown}
              ref={params.InputProps.ref}
              inputProps={params.inputProps}
            />
          );
        }}
      />
    </Fragment>
  );
};

SearchAutocomplete.propTypes = {
  classes: PropTypes.shape({}),
  search: PropTypes.string,
  suggestions: PropTypes.arrayOf(PropTypes.string),
  setSearch: PropTypes.func,
  onSearch: PropTypes.func,
  getSuggestions: PropTypes.func,
};

SearchAutocomplete.defaultProps = {
  suggestions: [],
};

export default SearchAutocomplete;
